import { memo, ReactChild, useCallback, useEffect, useState } from "react";

import PaymentConfirmation from "../payment.process/payment.process";
import { getQueryStringValue, IPaymentPartner, PHONE_STATUS, PREVIEW_MODE } from "../common";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

import { ICartItem, IPaymentDetail, usePaymnetContext } from "../../";
import { fetchPaymentLinkDetailAPI } from "../apiSercive";
import Step1 from "./Step1";
import Step2 from "./Step2";
import "./payment.card.scss";
import AddBank from "../../components/AddBank/AddBank";

const PaymentCard = memo(() => {
  const [selectedPayment, setSelectedPayment] = useState<IPaymentPartner>();
  const [show, setShow] = useState<boolean>(false);
  const { state, update } = usePaymnetContext();
  const [loading, setLoading] = useState<boolean>(false);
  const { t } = useTranslation();
  const togglePopup = (show: boolean) => setShow(show);

  const stepChange = useCallback(
    (index: number) => {
      if (state.paymentPartners.length > 0) {
        update({ ...state, stepIndex: index });
      }
    },
    [state]
  );

  const paymentSelect = (item?: any) => {
    setSelectedPayment(item);
    if (item.partnerType === "mno") {
      togglePopup(true);
      update({ ...state, phoneStatus: PHONE_STATUS.PHONE_REQUIRED });
    }
  };

  return (
    <div className="payment-card-wrapper">
      <div
        className="payment-card"
        style={{ justifyContent: loading ? "center" : "space-between" }}
      >
        {!loading && (
          <div className="header">
            {state.steps.map((item: number, index: number) => (
              <span
                key={item}
                className={`dot ${index == state.stepIndex ? "active" : ""}`}
                onClick={() => stepChange(index)}
              ></span>
            ))}
          </div>
        )}
        <div className="body">
          {state.stepIndex === 0 && (
            <Step1 loading={loading} setLoading={setLoading} />
          )}
          {state.stepIndex === 1 &&
            (selectedPayment?.partnerType === undefined ||
              selectedPayment?.partnerType === "mno") && (
              <Step2
                loading={loading}
                setLoading={setLoading}
                onPaymentSelect={paymentSelect}
              />
            )}
          {state.stepIndex === 1 && selectedPayment?.partnerType === "bank" && (
            <AddBank
              selectedPayment={selectedPayment}
              onPaymentSelect={paymentSelect}
            />
          )}
        </div>
        <div>
          {!loading && (
            <div className="footer">
              {state?.paymentDetail?.vendorId ===
                "00000000-0000-0000-0000-000000000000"
                ? t("powredBy", { year: new Date().getFullYear() })
                : t("powredByLipia", { year: new Date().getFullYear() })}
              <br />
              {t("visit")}:{" "}
              <a href={state.layout.poweredByURL} target="_blank">
                {t("visitURL")}
              </a>
            </div>
          )}
          {show && (
            <PaymentConfirmation
              selectedPayment={selectedPayment}
              onClose={() => {
                update({
                  ...state,
                  phone: { error: "", value: "" },
                  pin: { value: "", error: "" },
                });
                setShow(false);
              }}
            />
          )}
        </div>
      </div>
      {state.mode !== PREVIEW_MODE && !loading && (
        <footer className="contact-us">
          <img
            style={{ width: "4rem" }}
            src={
              state.layout.bottomLogo ||
              (state?.paymentDetail?.vendorId ===
                "00000000-0000-0000-0000-000000000000"
                ? `https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/payment-gateway-red.svg`
                : "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-icons/lipalink-grey.svg")
            }
            alt="payemnt gateway"
          />
          <span>
            {t("assistance")}
            <a
              className="contact"
              href={
                `${state.layout.contactUsURL}` ||
                "https://azampay.com/contact-us"
              }
              target="_blank"
            >
              {t("contactUs")}
            </a>
          </span>
        </footer>
      )}
      {state.mode === PREVIEW_MODE && (
        <div className="bottom-navigation">
          <span
            className="arrow"
            onClick={() => update({ ...state, stepIndex: 0 })}
          >
            &#60;
          </span>
          {state.steps.map((item: number, index: number) => (
            <span
              key={item}
              className={`dot ${index == state.stepIndex ? "active" : ""}`}
              onClick={() => update({ ...state, stepIndex: index })}
            >
              {index + 1}
            </span>
          ))}
          <span
            className="arrow"
            onClick={() => update({ ...state, stepIndex: 1 })}
          >
            &#62;
          </span>
        </div>
      )}
    </div>
  );
});

export const PaymentFor = () => {
  const { t } = useTranslation();
  const { state } = usePaymnetContext();

  return <div className="payment-for">
    <div className="payment-for-label">{t("paymentFor")}</div>
    {state.paymentDetail?.cart?.items.map((item: ICartItem) => {
      return <div key={item.name} className="purchasing-item">{item.name}</div>
    })}
  </div>
}

export const PaymentVendor = () => {
  const { state } = usePaymnetContext();
  return <div className="vendor-name">{state.paymentDetail?.vendorName || state.paymentDetail?.appName}</div>
}

export const PaymentAmount = () => {
  const { t } = useTranslation();
  const { state } = usePaymnetContext();

  return <div className="payment-wrapper">
    <div className="label">{t("amount", { currency: state.paymentDetail?.currency })}</div>
    <div className="amount">{t("intlNumber", { val: state.paymentDetail?.amount, locale: state.paymentDetail?.currency })}</div>
  </div>
}

export const PaymentButton = ({ src, alt, loading, className, btnIcon, onClick, children }:
  { src?: string; alt?: string; loading?: boolean; className?: string; btnIcon?: string; onClick?: () => void; children?: ReactChild }) => {
  return <button className={`payment-method-btn ${className}`} onClick={onClick}>
    {loading ? <span className="spinner-grow spinner-grow-sm"></span> :
      <>
        <span className="left-sec">
          <img className="link" src={src} alt={alt} />
          <span className="payment-name">{children}</span>
        </span>
        <img className="short-arrow-right" src={btnIcon} alt="arrow" />
      </>
    }
  </button>
}

export default memo(PaymentCard);